import React, { memo, ReactElement } from "react";

type IProps = { className?: string; "data-testid"?: string; color?: string };

enum COLOR {
    GREEN = "green",
}

function ArrowSvgComponentUx4(props: IProps): ReactElement {
    switch (props.color) {
        case COLOR.GREEN:
            return (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 14.54L12.105 10.4L8 6.26L8.9843 5L14 10.4L8.9843 15.8L8 14.54Z"
                        fill="#1BA672"
                    />
                </svg>
            );
    }

    return (
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" {...props} data-testid={props["data-testid"]}>
            <path d="M1 1.00024L6 6.00024L1 11.0002" stroke="#BABBC0" strokeWidth="1.5" />
        </svg>
    );
}

function ArrowSvgComponent(props: IProps): ReactElement {
    return <ArrowSvgComponentUx4 {...props} />;
}

export default memo(ArrowSvgComponent);
